<template>
  <div class="editInfo-wrap">
    <h2>General Information</h2>

    <p>Enter and Update all your General Information here.</p>
    <div class="information-form">
      <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
        <form
          @submit.stop.prevent="handleSubmit(updateInfo)"
          ref="employerGroupGeneralInfoContainer"
        >
          <div class="form-group row">
            <input-text
              labelFor="group_code"
              labelName="Group Code"
              :vmodel.sync="form.group_code"
              formGroupClass="col-xxl-4 col-lg-4 col-md-6 mb-3"
              readonly
            />
            <input-text
              :rules="{ required: true }"
              labelFor="group_name"
              labelName="Group Name "
              :vmodel.sync="form.group_name"
              formGroupClass="col-xxl-4 col-lg-4 col-md-6 mb-3"
            />
            <input-text
              :rules="{ required: true }"
              labelFor="tax_id"
              labelName="Tax ID"
              :vmodel.sync="form.tax_id"
              formGroupClass="col-xxl-4 col-lg-4 col-md-6 mb-3"
            />
            
          </div>
          <div class="form-group row">
            <input-text
              :rules="{ required: true }"
              labelFor="first_name"
              labelName="First Name  "
              :vmodel.sync="form.first_name"
              formGroupClass="col-xxl-4 col-lg-4 col-md-6 mb-3"
            />
            <input-text
              :rules="{ required: true }"
              labelFor="last_name"
              labelName="Last Name  "
              :vmodel.sync="form.last_name"
              formGroupClass="col-xxl-4 col-lg-4 col-md-6 mb-3"
            />
            <input-text
              :rules="{ required: false }"
              labelFor="fax"
              labelName="Fax"
              :vmodel.sync="form.fax"
              formGroupClass="col-xxl-4 col-lg-4 col-md-6 mb-3"
            />
          </div>
          <div class="form-group row">
            <input-multi-select
              labelFor="industry"
              labelName="Industry"
              inputName="industry"
              :vmodel.sync="form.industry"
              :options="groupIndustries.map((type) => type.value)"
              :custom-label="
                (opt) => groupIndustries.find((x) => x.value == opt).title
              "
              formGroupClass="col-xxl-4 col-lg-4 col-md-6 mb-3"
              inputClass="group-industry"
              placeholder="Select Industry"
            />
          </div>
          <div class="form-group row">
            <span class="col-xxl-4 col-lg-6 col-md-6 mb-3">
                                <!-- :rules="{ required: true, neverbounce: true }" -->

                <input-text
                  :rules="{ required: true, email: true }"
                  labelFor="email"
                  labelName="Email"
                  :vmodel.sync="form.email"
                  formGroupClass=""
                />
                <div class="mt-2 row justify-content-between validation-row">
                  <span class="validate-btn col-md-5 col-sm-6 d-flex rep-otp-validation" v-if="showOtpSectionEmail">
                    <a href="#" class="validate-via-otp-link " @click.prevent="openOtpModal('email')">
                        TO CONTINUE, PLEASE CLICK HERE TO VERIFY YOUR EMAIL.
                    </a>
                  </span>
                </div>

              <div v-if="emailMsg" class="message-container mt-2">
              <div :class="['validate-message', `${emailValidationMessage.type}`]">
            <div :class="['message-indicator', `${emailValidationMessage.type}-indicator`]"></div>
            <span class="message-text">
              <strong :class="`${emailValidationMessage.type}-text`">{{ emailValidationMessage.title }}</strong> - 
              {{ emailValidationMessage.message }}
            </span>

              <button type="button" class="close-btn" onclick="this.parentElement.style.display='none';">
                   <span aria-hidden="true">&times;</span>
              </button>
          </div>
          </div>
            </span>
            <!--  -->
<!--   :rules="{ required: true, digits: 10, clearoutPhone: true }" -->
            <span class="col-xxl-4 col-lg-6 col-md-6 mb-3">
              <input-text
                :rules="{ required: true, digits: 10}"
                labelFor="phone"
                labelName="Phone"
                :vmodel.sync="form.phone"
                formGroupClass=""
                 inputType="text"
                 maxlength="10"
                 inputmode="numeric"
                 pattern="\d*"
                 @input.native="enforceDigitLimit"
                 @keypress.native="onlyAllowDigits"
              />


              <div class="mt-2 row justify-content-between validation-row">
                  <span class="validate-btn col-md-5 col-sm-6 d-flex rep-otp-validation" v-if="showOtpSectionPhone">
                    <a href="#" class="validate-via-otp-link " @click.prevent="openOtpModal('phone')">
                        TO CONTINUE, PLEASE CLICK HERE TO VERIFY YOUR PHONE.
                    </a>
                  </span>
            </div>

            <div v-if="phoneMsg" class="message-container mt-2">
            <div :class="['validate-message', `${phoneValidationMessage.type}`]">
            <div :class="['message-indicator', `${phoneValidationMessage.type}-indicator`]"></div>
            <span class="message-text">
              <strong :class="`${phoneValidationMessage.type}-text`">{{ phoneValidationMessage.title }}</strong> - 
              {{ phoneValidationMessage.message }}
            </span>

              <button type="button" class="close-btn" onclick="this.parentElement.style.display='none';">
                 <span aria-hidden="true">&times;</span>
              </button>
          </div>
          </div>


            </span>
          </div>

          <div class="form-group row image-row">
            <input-image
              @deleteImage="deleteImage('logo')"
              ref="groupLogo"
              labelFor="group_logo"
              labelName="Logo"
              :vmodel.sync="group_logo"
              formGroupClass="col-xxl-4 col-xl-4 col-lg-4 col-md-6 mb-4"
              :imgSrc="groupLogoSrc"
              imgClass="group-upload-img"
            />

          </div>

        <div class="form-group row image-row">
            <input-image
             @deleteImage="deleteImage('cover')"
              ref="coverImage"
              labelFor="cover_photo"
              labelName="Cover Image"
              :vmodel.sync="cover_photo"
              formGroupClass="col-xxl-4 col-xl-4 col-lg-4 col-md-6 mb-4"
              :imgSrc="groupCoverSrc"
              imgClass="group-upload-img"
            />

          </div>

          <div class="row">
            <div class="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-12">
              <button type="submit" class="univ-btn">
                {{ isUpdate ? "Updating..." : "Update" }}
              </button>
            </div>
          </div>
        </form>
        <employer-email-verification
        v-if="showOtpModal"
        v-model="showOtpModal"
        :identifier="contactInfo"
        :identifierTypeText="otpType"
        @save="handleVerificationResult"
        @close="closeOtpModal"
        />
      </ValidationObserver>
    </div>
  </div>
</template>
<script>
import Api from "@/resource/Api";
import ApiSendOtp from "@/resource/BaseApi";
import Helper from "@/resource/Helper";
// import EmployerEmailVerification from "@/views/DownlineRep/modals/EmployerEmailVerification.vue";
import EmployerEmailVerification from "@/views/DownlineRep/Nuera/DownlineOTPNuera.vue";


export default {
  name: "EmployerGroupGeneralInfo",
  props: {
    generalInfo: {
      required: true,
    },
    groupIndustries: {
      required: true,
    },
  },
  components: {
    EmployerEmailVerification,
  },
  data: () => ({
    form: {
      group_id: "",
      group_code: "",
      group_name: "",
      group_landing_page: "",
      tax_id: "",
      industry: null,
      first_name: "",
      last_name: "",
      email: "",
      phone: "",
      fax: "",
    },
    showOtpModal: false,
    isUpdate: false,
    group_logo: null, 
    cover_photo: null, 
    groupLogoSrc: null,
    groupCoverSrc: null,
    phoneMsg: false,
    phoneValidationMessage:null,
    emailMsg: false,
    emailValidationMessage: null,
    showOtpSectionEmail: false,
 
    showOtpSectionPhone: false,
    
      contactInfo: null,
        otpType: null,
        validationStatus: null,
        emailVerified: false,
        phoneVerified: false,
        skipEmailVerification: false,
        skipPhoneVerification: false,

  }),
  methods: {
  enforceDigitLimit(event) {
    const raw = event.target.value;
    const digitsOnly = raw.replace(/\D/g, '').slice(0, 10);
    this.form.phone = digitsOnly;
    // Also fix the displayed value (if your component doesn't sync automatically)
    event.target.value = digitsOnly;
  },

   onlyAllowDigits(event) {
    const key = event.key;
    if (!/^\d$/.test(key)) {
      event.preventDefault();
    }
  },

    closeOtpModal() {
      this.showOtpModal = false;
    },


    handleVerificationResult(result) {
    if (result.verified) {
      // Handle successful verification
      if (result.type === 'email') {
        this.emailMsg = true;
        this.emailVerified = true;
        this.emailValidationMessage = {
          type: 'success',
          title: 'Success',
          message: 'Your email has been verified!'
        };
        this.form['skip_validation_email'] = 1;
        this.showOtpSectionEmail = false;
      } else if (result.type === 'phone') {
        this.phoneMsg = true;
        this.phoneVerified = true;
        this.form['skip_validation_phone'] = 1;
        this.phoneValidationMessage = {
          type: 'success',
          title: 'Success',
          message: 'Your phone has been verified!'
        };
        this.showOtpSectionPhone = false;
      }
      this.$notify('Verification successful!');
    } 
    else if (result.skipped) {
      // Handle skipped verification
      if (result.type === 'email') {
        this.skipEmailVerification = true;
        this.form['skip_validation_email'] = 1;
        this.emailMsg = true;
        this.emailValidationMessage = {
          type: 'success',
          title: 'Success',
          message: 'Email verification was skipped'
        };
        this.showOtpSectionEmail = false;
      } else if (result.type === 'phone') {
        this.skipPhoneVerification = true;
        this.form['skip_validation_phone'] = 1;
        this.phoneMsg = true;
        this.phoneValidationMessage = {
          type: 'success',
          title: 'Success',
          message: 'Phone verification was skipped'
        };
        this.showOtpSectionPhone = false;
      }
      this.$notify('Verification skipped', 'warning');
    }
  },

       async openOtpModal(type) {
      if (type === "email" && !this.form.email) {
        this.$notify("Please enter an email address first.", "error");
        return;
      }

      if (type === "phone" && !this.form.phone) {
        this.$notify("Please enter a phone number first.", "error");
        return;
      }

      if(type==="email"){
        this.contactInfo=this.form.email;
        this.otpType = type;
     this.sendOtp();
      }

      else{
        this.contactInfo=this.form.phone;
        
        this.otpType = type;
     this.sendOtp();

      }
      this.showOtpModal = true;

      // this.contactInfo = type === "email" ? this.form.email : this.form.cell_phone;
      
    },


  async sendOtp() {
   try {
    const response = await ApiSendOtp.post('api/v2/send-common-otp', {
      contact: this.contactInfo,
      type: this.otpType,
          //  no_attempt_limit: 1,
      expiry_duration: 600,
    
    });
    if (response.data.success === true || response.data.status === 'success') {
  this.$notify('OTP sent successfully!');

  } 
  else {
  this.$notify(response.data.message || 'Failed to send OTP. Please try again.', 'error');
}
  } catch (error) {
    this.$notify('Failed to send OTP. Please try again.', 'error');
    console.error('OTP send error:', error);
  }
},


 async   updateInfo() {
      this.phoneMsg = false;
      this.emailMsg = false;
      this.phoneValidationMessage = null;
      this.emailValidationMessage = null;
      this.showOtpSectionEmail = false;
      this.showOtpSectionPhone = false;
      
      
      this.isUpdate = true;
      const url = `v3/update-group-details?type=general`;
      let loader = this.$loading.show();
      let formData = new FormData();
      for (const [key, value] of Object.entries(this.form)) {
        if (value) {
          formData.append(key, value);
        }
      }
      if (this.group_logo) {
        formData.append("group_logo", this.group_logo);
      }
         if (this.cover_photo) {
        formData.append("cover_photo", this.cover_photo);
      }
    await Api.post(url, formData)
        .then((res) => {
          this.$notify(res.data.message);
          this.$emit("onSuccess");
          this.$refs.groupLogo.reset();
          this.form.skip_validation_email = 0;
          this.form.skip_validation_phone = 0;

        })
        .catch((err) => {
         const errorMsg = err.response?.data?.message;

       if (errorMsg.includes("Phone number is invalid.")) {
        this.phoneMsg = true;
        this.phoneValidationMessage = {
            type: "error",
            title: "Caution",
            message: "Invalid Phone Number, Please validate via OTP.",
          };
          this.showOtpSectionPhone = true;
          this.$notify("Phone is invalid. Please validate via OTP", "error");

          this.form.skip_validation_email = 1;
          this.form.skip_validation_phone = 0;


    }   
    else if (errorMsg.includes("Email is invalid.")){

        this.emailMsg = true;
        this.emailValidationMessage = {
            type: "error",
            title: "Caution",
            message: "Invalid Email Address, Please validate via OTP.",
          };
          this.showOtpSectionEmail = true;
        this.$notify("Email is invalid. Please validate via OTP", "error");
          this.form.skip_validation_email = 0;
          this.form.skip_validation_phone = 1;

    

    } else if(errorMsg.includes("Phone number and email are invalid.")) {

        this.emailMsg = true;
        this.phoneMsg = true;
        this.emailValidationMessage = {
            type: "error",
            title: "Caution",
            message: "Invalid Email Address, Please validate via OTP.",
          };
          this.phoneValidationMessage = {
            type: "error",
            title: "Caution",
            message: "Invalid Phone Mumber, Please validate via OTP.",
          };
          this.showOtpSectionEmail = true;
          this.showOtpSectionPhone = true;
           this.$notify("Email and Phone are invalid.", "error");
           this.form.skip_validation_email = 0;
          this.form.skip_validation_phone = 0;

    } else if(errorMsg.includes("Email is already taken.")){
        this.emailMsg = true;
        this.emailValidationMessage = {
            type: "error",
            title: "Caution",
            message: "The Email Address is already taken.",
          };
      this.$notify("The Email is already taken", "error");
                this.form.skip_validation_email = 0;
          this.form.skip_validation_phone = 1;
    }
    else if(errorMsg.includes("Phone number is already taken.")){
        this.phoneMsg = true;
        this.phoneValidationMessage = {
            type: "error",
            title: "Caution",
            message: "The Phone Number is already taken.",
          };
      this.$notify("The Phone Number is already taken", "error");
                this.form.skip_validation_email = 1;
          this.form.skip_validation_phone = 0;
    }
    else if(errorMsg.includes("Phone number and email are already taken.")){
       this.phoneMsg = true;
        this.phoneValidationMessage = {
            type: "error",
            title: "Caution",
            message: "The Phone Number is already taken.",
          };
     this.emailMsg = true;
        this.emailValidationMessage = {
            type: "error",
            title: "Caution",
            message: "The Email Address is already taken.",
          };
      this.$notify("The Email and Phone Number are already taken", "error");
          this.form.skip_validation_email = 0;
          this.form.skip_validation_phone = 0;
    }

    else if(errorMsg.includes("Email is already taken and phone number is invalid.")){
    this.emailMsg = true;
        this.emailValidationMessage = {
            type: "error",
            title: "Caution",
            message: "The Email Address is already taken.",
          };
      this.phoneMsg = true;
        this.phoneValidationMessage = {
            type: "error",
            title: "Caution",
            message: "Invalid Phone Number, Please validate via OTP.",
          };
          this.showOtpSectionPhone = true;

      this.$notify("The Email is already taken and Phone is invalid", "error");
                this.form.skip_validation_email = 0;
          this.form.skip_validation_phone = 0;

     }
else if(errorMsg.includes("Phone number is already taken and email is invalid.")){
  this.emailMsg=true;
        this.emailValidationMessage = {
            type: "error",
            title: "Caution",
            message: "Invalid Email Address, Please validate via OTP.",
          };
          this.showOtpSectionEmail = true;
      this.phoneMsg = true;
        this.phoneValidationMessage = {
            type: "error",
            title: "Caution",
            message: "The Phone Number is already taken.",
          };
      this.$notify("The Phone Number is already taken and Email is invalid", "error");
                this.form.skip_validation_email = 0;
          this.form.skip_validation_phone = 0;
}
     else {
      const messages = Array.isArray(errorMsg) ? errorMsg : [errorMsg];
      messages.forEach(msg => {
            if (msg) {
                this.$notify(msg, "error");
            }
        });
    }
        })
        .finally(() => {
          this.isUpdate = false;
          loader.hide();
          this.$refs.observer.reset();
        });
    },
    setFormData(value) {
      this.form = {
        group_id: value.group_id ? value.group_id : "",
        group_code: value.group_code ? value.group_code : "",
        group_name: value.group_name ? value.group_name : "",
        group_landing_page: value.group_landing_page
          ? value.group_landing_page
          : "",
        tax_id: value.tax_id ? value.tax_id : "",
        industry: value.industry ? value.industry : null,
        first_name: value.first_name ? value.first_name : "",
        last_name: value.last_name ? value.last_name : "",
        email: value.email ? value.email : "",
        phone: value.group_phone ? value.group_phone : "",
        fax: value.group_fax ? value.group_fax : "",
      };
      this.groupLogoSrc = value.group_logo ? value.group_logo : "";
      this.groupCoverSrc = value.cover_photo ? value.cover_photo : "";
    },
  async deleteImage(type = '') {
       const del = await Helper.confirmDialog('Confirm', 'Are you sure to delete this image?');
       if (del) {
          let url = (type =='logo') ? 'remove-group-logo' : 'remove-group-cover-image';
           return Api.delete(`v2/${url}/${this.form.group_id}`)
             .then((response) => {
                  this.$emit("onSuccess")
                   Api.notification(response.data.status, response.data.message);     
              })
                .catch (e => {
                  console.log(e);
                    Api.notification('error', 'Failed to delete image'); 
                });
            }
        },
  },
  watch: {
    generalInfo: function (value) {
      if (value) {
        this.setFormData(value);
      }
    },
  
  "form.email": {
    handler(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.form['skip_validation_email'] = 0;
        this.emailMsg = false;
        this.emailValidationMessage = null;
        this.showOtpSectionEmail = false;
      
      }
    },
    immediate: true
  },
  "form.phone": {
    handler(newVal, oldVal) {

    const cleaned = newVal.replace(/\D/g, '').slice(0, 10);
    if (newVal !== cleaned) {
      this.form.phone = cleaned;
    }

      if (newVal !== oldVal)
        this.form['skip_validation_phone'] = 0;
        this.phoneMsg = false;
        this.phoneValidationMessage = null;
        this.showOtpSectionPhone = false;
        
      }
    },
    immediate: true
  },
};
</script>
<style>
.image-row {
  display: inline-block;
  width: 50%;
}
.custom-file-input {
  width: 120% !important;
}

.uploaded {
    width: 116%;
    position: relative;
}

.rep-otp-validation {
  border: 2px solid #e31717;
  padding: 5px;
  margin-left: 14px;
  font-size: 13px;
  font-weight: bold;
  width: 385px;
}

.rep-otp-validation:hover {
  border: 2px solid #a50e0e;
  box-shadow: #eb2a2a;
  background-color: aliceblue;
  cursor: pointer;
}
</style>